module.exports = __webpack_public_path__ + "static/media/reset.2e5ebe71.svg";